
export class BuilderTokenMenuCtrl {
  constructor() {
  }

  $onInit() {
  }
}

export default {
  bindings: {
    activeToken: "=",
    showTokensContextMenu: "=",
    selectedTokens: "=",
    selectedReferenceId: "=",
    onDeselectTokenMenu: "&",
    onSelectTokenReferenceMenu: "&",
    onRemoveTokenMenu: "&",
    onAlignTokensMenu: "&",
    onFitTokensMenu: "&",
    onStackTokensMenu: "&",
    onTokenPropertiesMenu: "&",
    onSetCommonTokenStyles: "&"
  },
  controller: BuilderTokenMenuCtrl,
  templateUrl: 'form-builder/builder-token-menu/builder-token-menu.component.html',
}
